import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from 'models/lib/create_model';
import HitTypes from 'models/search/hit_types';

const Status = createEnum('OPEN', 'CLOSED');

export default createModel({
  modelName: 'TaskSearchHit',

  properties: {
    id: prop(String).isRequired,
    customer: prop({
      id: String,
      email: String,
      name: String,
      phone: String,
    }),
    assignee: prop({
      agent: String,
      group: String,
    }),
    matchingText: String,
    createdAt: String,
    updatedAt: String,
    dueAt: String,
    status: String,
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: HitTypes.TASK });
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
    Status,
  },
});
